import React from 'react';

import { Icon } from '@chakra-ui/react';

export const DetachIcon = props => (
  <Icon viewBox="0 0 17 17" color="inherit" h="full" w="full" {...props}>
    <path d="M10.646 13.146l0.707 0.707-2.853 2.854-2.854-2.854 0.707-0.707 1.647 1.647v-3.772h1v3.772l1.646-1.647zM8 2.207v3.772h1v-3.772l1.646 1.646 0.707-0.707-2.853-2.853-2.854 2.853 0.707 0.707 1.647-1.646zM0 8v1h17v-1h-17z" />
  </Icon>
);
